<template>
  <div id="scroll-div-latest-nav" class="main layer2" style="height: calc(100% - 2.5rem); padding-top: 2.5rem; overflow: auto;">
    <swiper :ad-list="adList"></swiper>
    <books-small :show-title="false" :books="books.small"></books-small>
    <books-large v-if="books.large.length > 0" :show-title="false" :books="books.large"></books-large>
    <loading ref="loading" scroll-div="scroll-div-latest-nav" :is-loading="isLoading" :is-no-more-data="isNoMoreData" @get-books="getBooks(currentPage + 1)"></loading>
  </div>
</template>

<script>
import Swiper from '@/components/share/swiper'
import BooksSmall from '@/components/share/books-small'
import BooksLarge from '@/components/share/books-large'
import Loading from '../../../components/share/loading'

import swiperService from '../../../services/swiperService'
import listService from '../../../services/listService'

export default {
  name: 'latest-nav',
  data () {
    return {
      componentName: '',
      adList: {},
      books: {
        small: [],
        large: []
      },
      isLoading: false,
      isNoMoreData: false,
      currentPage: 1
    }
  },
  methods: {
    getBooks (target) {
      this.currentPage = target
      if (target === 1) {
        this.books = { small: [], large: [] }
      }
      this.isLoading = true
      this.isNoMoreData = false
      listService.getLatest(target)
        .then(res => {
          this.isLoading = false
          if (res.result) {
            if (res.data.totalPage === 0) {
              this.books = { small: [], large: [] }
            } else if (this.currentPage === 1) {
              const data = res.data.bookList
              this.books.small = data.splice(0, 3)
              this.books.large = data
            } else if (this.currentPage > 1 && this.currentPage <= res.data.totalPage) {
              this.books.large.push(...res.data.bookList)
            }
            if (this.currentPage > res.data.totalPage && res.data.totalPage !== 0) {
              this.isNoMoreData = true
            }
          }
          setTimeout(() => {
            this.$refs.loading.scrollFunction()
          }, 0)
        })
    }
  },
  components: {
    swiper: Swiper,
    'books-small': BooksSmall,
    'books-large': BooksLarge,
    loading: Loading
  },
  mounted () {
    this.componentName = this.$route.name
    if (this.$store.state.pageState[this.componentName] && this.$router.isBack) {
      Object.assign(this.$data, this.$store.state.pageState[this.$route.name].data)
      setTimeout(() => {
        const scrollDiv = document.getElementById('scroll-div-latest-nav')
        scrollDiv.scrollTop = this.$store.state.pageState[this.$route.name].top
      }, 0)
    } else {
      this.adList = swiperService.getAdList()
      this.getBooks(1)
    }
    this.$router.isBack = true
  },
  beforeDestroy () {
    const scrollDiv = document.getElementById('scroll-div-latest-nav')
    const state = {}
    state[this.componentName] = { data: this.$data, top: scrollDiv.scrollTop }
    this.$store.commit('saveState', state)
  }
}
</script>

<style scoped>
</style>
